import * as React from 'react'

export const CloseIcon = () => {
  return (
    <svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.582267 3.39197C-0.198782 2.61092 -0.192997 1.35044 0.595188 0.576588C1.38337 -0.197261 2.65549 -0.191417 3.43654 0.589619L17.5951 14.7482L31.6947 0.648503C32.4758 -0.132534 33.7479 -0.138378 34.5361 0.635472C35.3243 1.40932 35.33 2.6698 34.549 3.45086L20.4234 17.5765L34.5492 31.7023C35.3303 32.4834 35.3245 33.7439 34.5363 34.5177C33.7481 35.2916 32.476 35.2857 31.695 34.5047L17.5951 20.4048L3.43629 34.5636C2.65524 35.3446 1.38313 35.3504 0.594944 34.5766C-0.193241 33.8027 -0.199026 32.5423 0.582023 31.7612L14.7668 17.5765L0.582267 3.39197Z'
        fill='#CCCCCC'
      />
    </svg>
  )
}
